<!-- Items badge (bid items + activities) -->
@if (type === 'items') {
  <div
    class="no-location-badge items-badge"
    [class.non-fullscreen]="!isFullScreen"
    [class.not-clickable]="!clickable"
    (click)="onClick($event)"
    >
    <div class="badge-icon">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <!-- Pin stroke (centered in 20x20, offset by 3px from left, 1px from top) -->
        <path d="M13.2617 2.99804C12.3081 2.37478 11.1483 2.00934 9.89718 2.00934C6.64472 2.00934 4.00934 4.47939 4.00934 7.52855C4.00934 8.45567 4.53445 9.76215 5.27102 11.1387M15.7611 7.89718C15.3544 11.2113 9.89681 17.9906 9.89681 17.9906C9.89681 17.9906 9.09026 17.299 7.94246 15.6788" stroke="#1036D6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <!-- Diagonal slash (centered in 20x20, offset by 2px from left and top) -->
        <line x1="16.9734" y1="3.0266" x2="3.0266" y2="16.9734" stroke="#1036D6" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </div>
    <div class="badge-count">{{ displayCount }}</div>
  </div>
}

<!-- Pictures badge (circular thumbnail with superscript) -->
@if (type === 'pictures') {
  <div
    class="no-location-badge pictures-badge"
    [class.has-items-badge]="hasItemsBadge"
    [class.non-fullscreen]="!isFullScreen"
    (click)="onClick($event)"
    >
    <!-- Circular thumbnail container -->
    <div class="circular-thumbnail-container">
      @if (thumbnailUrl) {
        <img
          [src]="thumbnailUrl"
          alt="No location picture"
          class="circular-thumbnail"
          />
      }
    </div>
    <!-- Superscript badge: white background, blue icon + text -->
    <div class="no-loc-superscript">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <!-- Pin stroke (scaled down and centered) -->
        <path d="M9.0832 1.3987C8.3157 0.862546 7.40383 0.556537 6.42802 0.556537C3.75130 0.556537 1.55653 2.53557 1.55653 4.86999C1.55653 5.61897 1.97412 6.68351 2.58972 7.79709M10.9828 4.92802C10.6480 7.64791 6.42766 12.7434 6.42766 12.7434C6.42766 12.7434 5.76318 12.1593 4.85972 10.8751" stroke="#1036D6" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
        <!-- Diagonal slash (scaled down and centered) -->
        <line x1="11.8813" y1="1.1186" x2="2.1186" y2="11.8813" stroke="#1036D6" stroke-width="1.4" stroke-linecap="round"/>
      </svg>
      <span class="no-loc-count">{{ displayCount }}</span>
    </div>
  </div>
}
